import type {Address} from './Address';
import type {EmailData} from './EmailData';
import type {IdentityCard} from './IdentityCard';
import type {PersonData} from './PersonData';
import type {PhoneNumberData} from './PhoneNumberData';

export type Person = {
  id: string;
  personData: PersonData;
  phoneNumbers: Array<PhoneNumberData>;
  emails: Array<EmailData>;
  identityCards: Array<IdentityCard>;
  permanentAddress: Address | null;
};
